import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";

import WPTertiaryButton from "../../../packages/WPTertiaryButton";
import { moreIcon } from "../../../assets";
import { DeleteIcon, EditIcon } from "../../../assets/icons";
import ConfirmationPopup, {
  DIALOG_TYPES,
} from "../../../packages/ConfirmationPopup";
import { deleteCip } from "../../../network/cipAPI";
import createNotification, {
  SUCCESS_NOTIFICATION,
  ERROR_NOTIFICATION,
} from "../../../components/Notifications";
import { CustomModalButtons } from "../../../constants/global.constants";
import CIPEventDialog from "../../CIPEventDialog";

import "./ActionsPopover.scss";

const ActionsPopover = ({ params, showLoader, refreshTable }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showEditCIPEventDialog, setShowEditCIPEventDialog] = useState(false);

  const { t } = useTranslation();
  const iconRef = useRef();
  const { cip_id, train_num } = params;

  const onEdit = () => {
    handleClose();
    setShowEditCIPEventDialog(true);
  };

  const onDelete = () => {
    handleClose();
    setShowDeleteConfirmation(true);
  };

  const proceedWithDelete = async (id) => {
    setShowDeleteConfirmation(false);

    if (id === CustomModalButtons.CONFIRM) {
      showLoader && showLoader(true);
      try {
        const deleteCips = await deleteCip(cip_id, train_num);
        if (deleteCips && deleteCips.status === 200) {
          createNotification(
            SUCCESS_NOTIFICATION,
            t("notificationStrings.deleteSuccess"),
            ""
          );
          refreshTable && refreshTable(); //get cips call
        } else {
          throw new Error("Failed to delete CIP");
        }
      } catch (err) {
        showLoader && showLoader(false);
        createNotification(
          ERROR_NOTIFICATION,
          t("notificationStrings.somethingWrong"),
          ""
        );
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="cip-actions-wrapper">
      <Tooltip title="Actions" arrow>
        <img
          ref={iconRef}
          src={moreIcon}
          alt="More"
          onClick={handleClick}
          className="more-icon"
        />
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="cip-actions">
          <WPTertiaryButton
            onClick={onEdit}
            label={`${t("ValueStrings.view")} & ${t("ValueStrings.edit")}`}
            icon={<EditIcon aria-label="Edit Icon" />}
            iconPlacement="before"
            className="edit"
          />
          <WPTertiaryButton
            onClick={onDelete}
            label={t("ValueStrings.delete")}
            icon={<DeleteIcon aria-label="Delete Icon" />}
            iconPlacement="before"
            className="delete"
          />
        </div>
      </Popover>
      {showEditCIPEventDialog && (
        <CIPEventDialog
          editedRow={params}
          onModalClose={() => setShowEditCIPEventDialog(false)}
          showLoader={showLoader}
          refreshTable={refreshTable}
          source={params.source}
        />
      )}
      {showDeleteConfirmation && (
        <ConfirmationPopup
          header={t("deleteCIP.header")}
          description={t("notificationStrings.deleteConfirmationCIP")}
          type={DIALOG_TYPES.ERROR}
          onClose={proceedWithDelete}
          confirmBtn={t("CIPSpecifications.removeC/S")}
          cancelBtn={t("ValueStrings.cancel")}
        />
      )}
    </div>
  );
};

export default ActionsPopover;
